import { Auth } from "aws-amplify";
import { v4 as uuid } from "uuid";

const AmplifyAuthService = {};

// AUTH SERVICES

AmplifyAuthService.currentSessionRequest = async () => {
  return await Auth.currentSession();
};

AmplifyAuthService.signInEmailRequest = async (username, password) => {
  const res = await Auth.signIn(username, password);
  return res;
};

AmplifyAuthService.signOutRequest = async () => {
  return await Auth.signOut();
};
// Function for signup of the first user of the company
AmplifyAuthService.signUpEmailRequest = async (
  annualIncome,
  businessType,
  code,
  companyName,
  consultant,
  confirm,
  currency,
  email,
  endDate,
  period,
  discount,
  lastName,
  mainCountry,
  name,
  numEmployees,
  password,
  planID,
  price,
  remember,
  startDate,
  subscriptionID,
  stripeCustomer,
  stripePriceID,
  trial,
  paymentReceived,
  billingID,
  phoneNumber,
  phoneCode,
  ipAddress,
  userAgent
) => {
  const companyID = uuid();
  const userID = uuid();
  return await Auth.signUp({
    username: email,
    password: password,
    validationData: {
      firstSignUp: "true",
      annualIncome: annualIncome,
      numEmployees: numEmployees,
      mainCountry: mainCountry,
      businessType: businessType,
      code: code,
      consultant: consultant,
      currency: currency,
      endDate: endDate,
      startDate: startDate,
      mainEmail: email,
      phoneNumber: phoneCode + phoneNumber.toString(),
      period: period.toString(),
      discount: discount.toString(),
      planID: planID,
      price: price.toString(),
      name: name,
      family_name: lastName,
      role: "1", // other custom attributes
      companyName: companyName,
      subscriptionID: subscriptionID,
      stripeCustomer: stripeCustomer,
      stripePriceID: stripePriceID,
      trial: trial.toString(),
      paymentReceived: paymentReceived.toString(),
      billingID: billingID,
      ipAddress: ipAddress,
      userAgent: userAgent,
    }, // Optional, an object of key-value pairs which can contain any key and will be passed to your Lambda trigger as-is.
    attributes: {
      email: email,
      "custom:companyID": companyID,
      "custom:userID": userID,
      "custom:isSuperAdmin": "true",
    },
    autoSignIn: {
      // optional - enables auto sign in after user is confirmed
      enabled: false,
    },
  });
};

// Function for the posterior signups of the company
AmplifyAuthService.signUpEmailRequestAdmin = async (
  companyID,
  username,
  name,
  lastName,
  password,
  role,
  countryID
) => {
  const userID = uuid(); // Genera un ID único
  try {
    // Realiza el registro de usuario en Cognito
    const signUpResponse = await Auth.signUp({
      username: username,
      password: password,
      validationData: {
        firstSignUp: "false",
        name: name,
        family_name: lastName,
        role: role, // otros atributos personalizados
        countryID: countryID,
      },
      attributes: {
        email: username,
        "custom:companyID": companyID,
        "custom:userID": userID, // Guarda el userID personalizado en Cognito
        "custom:isSuperAdmin": "false",
      },
      autoSignIn: {
        enabled: false, // no habilitar el inicio de sesión automático
      },
    });

    // Ahora puedes retornar el `userID` que se guardó en los atributos personalizados
    return {
      userSub: signUpResponse.userSub, // El userSub estándar de Cognito
      userID: userID, // El userID generado que es el ID que guardaste en la base de datos
    };
  } catch (error) {
    console.error("Error during sign up:", error);
    throw error;
  }
};

AmplifyAuthService.forgotPasswordCodeGen = async (username) => {
  return await Auth.forgotPassword(username);
};

AmplifyAuthService.forgotPasswordSubmitNewPass = async (
  username,
  code,
  new_password
) => {
  return await Auth.forgotPasswordSubmit(username, code, new_password);
};

AmplifyAuthService.removeUser = async () => {
  return await Auth.deleteUser();
};

export default AmplifyAuthService;
